import React, { useContext, useRef } from 'react';
import { useRouter } from 'next/router';
import { w as withProviders } from '../../withProviders-l3mjYkR2.js';
import { getCategoryLink } from '../../utils/category.js';
import Breadcrumbs from '../Breadcrumbs/index.js';
import { C as CategoryHeader } from '../../CategoryHeader-s-kLV-J5.js';
import { C as CategorySEO } from '../../CategorySEO-5I-hA5gp.js';
import { C as CategoryItem } from '../../CategoryItem-P72rIIRv.js';
import { P as ProductItem } from '../../ProductItem-HE5bs1gx.js';
import { C as CategoryBanner } from '../../CategoryBanner-Jp_beYYn.js';
import { CoreContext } from '../../context/index.js';
import '../../utils/logToSlack.js';
import useAnimate from '../../hooks/useAnimate.js';
import 'cookies-next';
import '../../currency-_kacFJHO.js';
import '../../language-BHHwgtQp.js';
import '../../payment-a4IKjS7g.js';
import '../../index-dEXHnASi.js';
import 'notistack';
import 'next-i18next';
import 'lodash/get';
import '../../product-_pRduMz7.js';
import '../../helpers-WYINLSKJ.js';
import 'lodash';
import 'react-i18next';
import '../../cookies-VX_DpI1q.js';
import '../../paths-ZKN3m62_.js';
import '../../GetCategoryBanner-HmQDOvcO.js';
import '../../GetCategoryYmals--jYLM2RK.js';
import '../../UrlResolver-OFrekbEP.js';
import '../../requestsCollection-A0HzS4ai.js';
import 'graphql-request';
import 'lodash/cloneDeep';
import '../../services/auth/index.js';
import '../../utils/cookies.js';
import '../../utils/isBot.js';
import '../../utils/currency.js';
import '../../utils/fetchPolicyLookup.js';
import '../../types/index.js';
import '../../checkout-Ee1eEXQH.js';
import '../../menu-0TyOg98i.js';
import '../../modal-6vnX5SO3.js';
import '../../utils/error.js';
import '../../serverErrors-O6unZmFR.js';
import '../../utils/logger.js';
import '../../utils/logToRelic.js';
import '../../utils/product.js';
import '../Link/index.js';
import '../../index-2586sEvh.js';
import '../../_commonjsHelpers-jjO7Zipk.js';
import 'next/link';
import '../../utils/image.js';
import '../../utils/saleFlag.js';
import '../../SaleFlag-uqbhEU3Y.js';
import '../../animations--PMkOS0j.js';
import '../../index-RkBJ48Nr.js';
import '../../hooks/useShowError.js';
import '../../selectItem-AV_wgSCj.js';
import '../../hooks/useItemListName.js';
import '../../utils/dataRouteFormat.js';
import '../../utils/cart.js';
import '../../MergeCarts-sPldCtIn.js';
import '../../ProcessReactivateCart-uQs33rRl.js';
import '../../utils/price.js';
import 'number-currency-format';
import '../../cart-AU0vdOfm.js';
import '../../ColorSwitcher-MEwboHHe.js';
import 'react-hook-form';
import '../../RadioGroup-ZDexyLRv.js';
import '../../RadioButton-iQCBhrqj.js';
import '../../ScreenDetector-P-WSDsqJ.js';
import '../../hooks/useOnScreen.js';
import '../WishlistButton/index.js';
import '../../storeSelectors/user.js';
import '../../storeSelectors/wishlist.js';
import '../../localStorage-h6SlcHvK.js';
import '../../hooks/useShowNotify.js';
import '../Loader/index.js';
import '../CircularProgress/index.js';
import '../Modal/index.js';
import '../OnlyUIRender/index.js';
import '../Modal/ModalContent/index.js';
import 'react-dom';
import '../../hooks/useAutoFocus.js';
import '../../hooks/useGetPortalRoot.js';
import '../../utils/portalRoot.js';
import '../FocusTrap/index.js';
import '../IconButton/index.js';
import '../Modal/ModalHeader/index.js';
import '../JustAddedProducts/index.js';
import '../Button/index.js';
import '../ButtonGroup/index.js';
import '../../hooks/useWindowSize.js';
import '../../store/modal/index.js';
import '@reduxjs/toolkit';
import '../../store/modal/initialState.js';
import '../../ShopButton-3jX2bKPw.js';
import '../../selectItem-UJ5YRly2.js';
import '../../Prices-J1SqTpik.js';
import 'i18next';
import '../../index-itNs9E93.js';

const getBreadcrumbs = (category, locale) => {
    const parentCategoriesBreadcrumbs = category.breadcrumbs || [];
    return [
        ...parentCategoriesBreadcrumbs.map(item => ({
            name: item.category_name,
            url: getCategoryLink(item.category_url_path, locale),
        })),
        {
            name: category.name,
            url: getCategoryLink(category.url_path, locale),
        },
    ];
};

const CategoryYMAL = ({ ymal }) => (React.createElement("div", { className: "ymal-container" }, ymal));

const Category = ({ category, categoryItems, banner, enableColorSwitcher, enableInlineCategoryHeader = false, categoryHeaderOverride, categorySEOOverride, allowAboveFoldAnimation = false, categoryServices, ymal, 
// ymalCarouselSkeleton,
forceColorSwitcherSpacing = false, }) => {
    const { data: { siteConfig: { category: { imageEagerLoadingAmount = 0, colorSwitcher = false, colorSwitcherMode = 'click', displayPrices = false, } = {}, }, }, } = useContext(CoreContext);
    const { locale } = useRouter();
    const breadcrumbItems = getBreadcrumbs(category, locale);
    const itemsCount = categoryItems.length;
    const animateRef = useRef(null);
    useAnimate(animateRef, null, category);
    return (React.createElement("div", { className: "category-page", ref: animateRef },
        React.createElement("div", { className: "category-page--top-wrapper" },
            React.createElement(Breadcrumbs, { items: breadcrumbItems, currentItem: category.name }),
            !enableInlineCategoryHeader && (React.createElement(CategoryHeader, { category: category, categoryHeaderOverride: categoryHeaderOverride }))),
        React.createElement("section", { className: `category product-list q${itemsCount}` },
            itemsCount > 0 && (React.createElement(React.Fragment, null,
                React.createElement(CategoryBanner, { banner: banner }),
                enableInlineCategoryHeader && (React.createElement(CategoryHeader, { category: category, categoryHeaderOverride: categoryHeaderOverride })),
                categoryItems.map((item, index) => {
                    const isCategory = !!item.category_data;
                    const categoryData = item.category_data;
                    const productData = item.product_data;
                    return isCategory ? (React.createElement(CategoryItem, { key: categoryData.url_path, item: categoryData, locale: locale, lazyLoad: index + 1 > imageEagerLoadingAmount, allowAboveFoldAnimation: allowAboveFoldAnimation })) : (React.createElement(ProductItem, { key: productData.sku, index: index, product: productData, enableColorSwitcher: enableColorSwitcher || colorSwitcher, colorSwitcherMode: colorSwitcherMode, itemsCount: itemsCount, locale: locale, lazyLoad: index + 1 > imageEagerLoadingAmount, allowAboveFoldAnimation: allowAboveFoldAnimation, displayPrices: displayPrices, forceColorSwitcherSpacing: forceColorSwitcherSpacing }));
                }))),
            itemsCount === 0 && (React.createElement("div", { className: "stack category-empty" },
                React.createElement("h2", { className: "category-empty-title" }, "No products found"),
                React.createElement("p", { className: "category-empty-text" }, "We are sorry, but there are no products in this category.")))),
        categoryServices && React.createElement("div", { className: "category-services-container" }, categoryServices),
        ymal ? (
        // TODO: Add Suspense and load YMAL separately from the main category query
        // <Suspense fallback={ymalCarouselSkeleton}>
        React.createElement(CategoryYMAL, { ymal: ymal })) : // </Suspense>
            null,
        React.createElement(CategorySEO, { category: category, categorySEOOverride: categorySEOOverride })));
};
var Category$1 = withProviders(Category, { translation: true, snackbar: true });

export { CategoryHeader, CategorySEO, Category$1 as default };
//# sourceMappingURL=index.js.map
